module.exports = __webpack_public_path__ + "static/img/zngk_p3.5149af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngk_p3.png
// module id = SPfU
// module chunks = 19